import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	migrationInfo: {
		id: 'admin-pages-priority-schemes.common.locked-cell.migration-info',
		defaultMessage:
			'We’re updating a priority scheme and you can edit priority schemes after we’re done.',
		description:
			'Tooltip content to inform users the schemes for priorities associated with their projects are locked due to an existing migration',
	},
});

export default messages;
